import React, { useState, useRef, useEffect } from "react";
import "./index.css";
import { QRCodeCanvas } from "qrcode.react";
import PrimaryRightIconFill from "../../_utils/CommonButtons/PrimaryRightIconFill";
import IconRoundButton from "../../_utils/CommonButtons/IconRoundButton";
import ICONS from "../../../assets/Icons";
import { GlobalConfiguration } from "../../../utils/configurationProvider";

const SCROLL_AMOUNT = 320;
const ScannerModal = ({
  isScannerOpen,
  url,
  setIsScannerOpen,
  appType,
  defaultStore,
  setUrl,
  setAppType,
}) => {
  const [appName, setAppName] = useState(defaultStore);
  const scrollRef = useRef(null);

  useEffect(() => {
    setAppName(defaultStore);
  }, [defaultStore]);

  return (
    <div
      className={`totp-scanner-popup ${
        isScannerOpen ? "totppopup-show" : "totppopup-close"
      }`}
    >
      <div className="main__scanner__popup_box">
        <div className="flex w-full items-center justify-between">
          <div className="flex w-full items-center gap-gap-sm py-padding-xs px-padding-sm">
            <img
              src={appType.icon}
              alt="Img"
              className="h-icon-md w-icon-md"
            />
            <p className="text-base font-semibold  text-text-primary">
              {appType.name}
            </p>
          </div>

          <IconRoundButton
            btnType="button"
            handleFunction={() => {
              if (scrollRef?.current) {
                scrollRef.current.scrollTo({
                  left: 0,
                  behavior: "auto",
                });
              }
              setIsScannerOpen(false);
              if (appType.name.toLowerCase() !== "passwords")
                setAppName("playstore");
            }}
            enabledBgColor="var(--primary-nav)"
            isLoading={false}
            icon={ICONS?.CLOSE}
            hoverOption="white"
            title="Close Field"
          />
        </div>
        <div className="scanner_div">
          <div
            className="flex flex-row app-slider"
            style={{
              borderRadius: "var(--border-radius-l)",
              height: "var(--height-totp-scanner)",
              background: "var(--primary-card)",
            }}
          >
            <div
              className={`slider-show-app`}
              style={{
                left:
                  appName === "playstore"
                    ? "var(--left-base)"
                    : "var(--left-half)",
              }}
            ></div>
            <div
              className={`
                 slider-play
                 ${defaultStore === "appstore" ? "opacity-light-opacity pointer-events-none" : ""}
                 ${appName !== "playstore" ? "global-hover-white relative z-z-index-base" : ""}
               `}
              onClick={() => {
                if (defaultStore === "appstore") return;
                if (scrollRef?.current) {
                  scrollRef.current.scrollBy({
                    left:
                      appName === "playstore" ? SCROLL_AMOUNT : -SCROLL_AMOUNT,
                    behavior: "smooth",
                  });
                }
                setAppName("playstore");
              }}
            >
              <img
                src={
                  "https://q2pay.in/new_assets/common/store/appstore_link.svg"
                }
                alt="app"
                className="w-icon-md h-icon-md"
              />
            </div>

            <div
              className={`slider-app ${appName !== "appstore" ? "global-hover-white relative z-z-index-base" : ""}`}
              onClick={() => {
                if (scrollRef?.current) {
                  scrollRef.current.scrollBy({
                    left:
                      appName === "playstore" ? SCROLL_AMOUNT : -SCROLL_AMOUNT,
                    behavior: "smooth",
                  });
                }
                setAppName("appstore");
              }}
            >
              <img
                src={
                  "https://q2pay.in/new_assets/common/store/playstore_link.svg"
                }
                alt="play"
                className="w-icon-md h-icon-md"
              />
            </div>
          </div>
          <div className="flex flex-col gap-gap-md p-padding-md justify-center items-center bg-[var(--brand-primary-surface-default)]">
            <div className="flex flex-col gap-gap-sm items-center">
              <div
                className="main-scan-div"
                ref={scrollRef}
              >
                <div className="main-scan-div-child">
                  <div className="pop-up-scan">
                    <QRCodeCanvas
                      value={url[1]}
                      size={GlobalConfiguration?.scannerSize}
                    />
                  </div>
                </div>
                <div className="main-scan-div-child">
                  <div className="pop-up-scan">
                    <QRCodeCanvas
                      value={url[0]}
                      size={GlobalConfiguration?.scannerSize}
                    />
                  </div>
                </div>
              </div>
              <p className="text-text-primary font-normal text-sm whitespace-nowrap overflow-hidden truncate">
                Scan QR code and download the app.
              </p>
            </div>
            <div className="w-full">
              <PrimaryRightIconFill
                hoverOption="white"
                btnText="Open in browser and download."
                btnType="button"
                enabledBgColor="var(--primary-nav-act)"
                isDisabled={false}
                icon={ICONS?.REDIRECT}
                enabledTextColor="var(--text-primary)"
                handleFunction={(e) => {
                  // const targetUrl = appName === "playstore" ? url[0] : url[1];
                  const targetUrl = appName === "playstore" ? url[1] : url[0];
                  window.open(targetUrl, "_blank");
                }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ScannerModal;
